// Shown on every logged-out surface: the login screen and the public invoice/estimate pages.
//
// These pages are what customers receive by SMS, so they are also what carrier URL scanners
// fetch. A page that is nothing but a credential form or a bare document viewer, with no
// statement of who runs the domain and no reachable policies, scores as phishing - which is
// how servicestrike.com ended up filtered on all three US carriers (Telnyx 40002).
//
// Links point at the indexed marketing site on purpose: the association between the app host
// and the registered brand domain is the thing a scanner needs to see.
const SITE = 'https://servicestrike.com';

export function LegalFooter() {
  return (
    <footer className="mt-8 pb-8 px-4 text-center text-xs text-secondary-500">
      <p className="mb-2">
        Service Strike - field service management software for scheduling, dispatch,
        invoicing and payments.
      </p>
      <p className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1">
        <a className="underline hover:text-secondary-700" href={SITE}>servicestrike.com</a>
        <a className="underline hover:text-secondary-700" href={`${SITE}/privacy-policy.html`}>Privacy Policy</a>
        <a className="underline hover:text-secondary-700" href={`${SITE}/terms-and-conditions.html`}>Terms &amp; Conditions</a>
        <a className="underline hover:text-secondary-700" href={`${SITE}/contact.html`}>Contact</a>
      </p>
    </footer>
  );
}
